import { useSelector } from 'react-redux'; // provided by ws-scripts

/**
 * Returns the server-detected device type ('MOBILE' | 'DESKTOP' | undefined).
 * Reads from the requestData slice populated by ws-scripts at SSR time.
 *
 * @returns {'MOBILE'|'DESKTOP'|undefined}
 */
const useDeviceType = () =>
	useSelector((state) => state.requestData?.deviceType);

export default useDeviceType;
